import type { ReactNode } from "react";

type DashboardZoneProps = {
  title: string;
  description?: string;
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function DashboardZone({
  title,
  description,
  children,
  actions,
  className = "",
}: DashboardZoneProps) {
  return (
    <section
      aria-label={title}
      className={`space-y-4 ${className}`.trim()}
    >
      <header className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          <h2 className="text-lg font-semibold tracking-tight text-[#111827]">
            {title}
          </h2>
          {description ? (
            <p className="mt-0.5 text-sm text-[#6B7280]">{description}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            {actions}
          </div>
        ) : null}
      </header>
      {children}
    </section>
  );
}
